<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="factories_new" ttGoto="factory" [ttGotoParms]="{ factory_id: '+' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListFactories"></tt-list>
</tt-page>
